"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"

export default function Scroll() {
  // when clicking a link, user will not scroll to the top of the page if the header is sticky.
  // this useEffect is a workaround to 'fix' that behavior.

  const pathname = usePathname()
  useEffect(() => {
    // window.scrollTo({ top: 0, behavior: "smooth" })
  }, [pathname])

  return <></>
}
